module.exports = __webpack_public_path__ + "img/BET365.ES.ba845288.svg";